import type dayjs from 'dayjs';

export const compareStrings = (first?: string | null, second?: string | null): number => {
  const f = first || '';
  const s = second || '';

  return f.localeCompare(s);
};

export const compareMultipleStrings = (first: string[], second: string[]): number => {
  const f = first.reduce((acc, item) => (item ? `${acc} ${item}` : acc), '');
  const s = second.reduce((acc, item) => (item ? `${acc} ${item}` : acc), '');

  return f.localeCompare(s);
};

export const compareNumbers = (a: number, b: number): number => {
  if (a > b) {
    return 1;
  }

  if (a === b) {
    return 0;
  }

  return -1;
};

export const compareBoolean = (first?: boolean, second?: boolean): number => {
  const f = first || false;
  const s = second || false;

  if (f && s) {
    return 1;
  }
  if (f === s) {
    return 0;
  }
  return -1;
};

export const compareBooleanDesc = (a?: boolean, b?: boolean): number => {
  // true hodnoty budou první (descending = sestupně)
  if (a === b) return 0;
  if (a && !b) return -1; // a je true, b je false -> a má být první
  return 1; // b je true, a je false -> b má být první
};

export const compareDates = (first?: string | null, second?: string | null): number => {
  const f = first || '';
  const s = second || '';

  return f.localeCompare(s);
};

export const compareDayjsDates = (
  // ascending
  first?: dayjs.Dayjs | null,
  second?: dayjs.Dayjs | null
) => {
  if (first?.isSame(second)) {
    return 0;
  }
  if (first?.isAfter(second)) {
    return 1;
  }
  return -1;
};

export const compareDayjsDatesDesc = (
  // descending
  first?: dayjs.Dayjs | null,
  second?: dayjs.Dayjs | null
) => {
  if (first?.isSame(second)) {
    return 0;
  }
  if (first?.isAfter(second)) {
    return -1;
  }
  return 1;
};

export const sortGroupKeys = (groupKey: string) => {
  if (groupKey === 'undefined') return 1;

  return -1;
};
